import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-10 mb-10" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Nome Serviço:", -1)
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Código:", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Quantidade Peça ou Tempo MO:", -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Preço Total:", -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0 required" }, "Descrição/Vídeo/Imagem:", -1)
const _hoisted_15 = { class: "d-flex w-100 justify-content-end" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save text-white" }, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "indicator-label"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle me-2" }, null, -1)

import { reactive, ref, onMounted, watch, nextTick } from "vue";
import { useStore } from "vuex";
import useAlert from "@/composables/Alert";
import useEmitter from "@/composables/Emmiter";
import { ItemDetailRevision, ItemDescription } from "@/models/CardapioModel";
import { updateRevisionItem, itemDescription } from "@/services/CardapioService";
import Swal from "sweetalert2/dist/sweetalert2.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormRevisionItem',
  props: {
    updateRevisionItem: {}
  },
  setup(__props: any) {

const props = __props;

const optionItemDescription = ref<ItemDescription[]>([]);
const ruleFormRef = ref();
const emitter = useEmitter();
const { showTimeAlert } = useAlert();
const store = useStore();
const form = reactive({
  peca: "",
  codigoPeca: "",
  qtdPeca: "",
  precoPeca: "",
  dadosExtra: 0,
});
const money = {
  decimal: ",",
  thousands: ".",
  prefix: "R$ ",
  precision: 2,
};
const codConcessionaria = localStorage.getItem("filtroConcessionaria");
const loading = reactive({
  submit: false,
  optionDescription: false,
});
const rules = reactive({
  peca: [
    {
      required: true,
      message: "Por favor, digite um nome.",
      trigger: "blur",
    },
  ],
  codigoPeca: [
    {
      required: true,
      message: "Por favor, digite um código.",
      trigger: "blur",
    },
  ],
  qtdPeca: [
    {
      required: true,
      message: "Por favor, preencha. O preenchimento é obrigatório.",
      trigger: "blur",
    },
  ],
});

onMounted(() => {
  getItemDescription();
});

watch(
  () => props.updateRevisionItem,
  (newValue) => {
    if (newValue) {
      form.codigoPeca = newValue.codigoPeca;
      form.dadosExtra = newValue.dadosExtra;
      form.peca = newValue.peca;
      form.qtdPeca = newValue.qtdPeca;

      nextTick(() => {
        form.precoPeca = newValue.precoPeca;
      });
    }
  },
  { deep: true, immediate: true }
);

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      Swal.fire({
        title: "Deseja fazer alterações no item?",
        showCancelButton: true,
        confirmButtonText: "Salvar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        text: "As alterações serão refletidas no app assim que forem salvas.",
      }).then((result) => {
        if (result.isConfirmed) {
          handleSubmit();
        } else if (result.isDenied) {
        }
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};

const handleSubmit = async () => {
  if (codConcessionaria && typeof codConcessionaria == "string") {
    const payload = {
      ...form,
      codConcessionaria: codConcessionaria,
      precoPeca: form.precoPeca.replace("R$", "").trim(),
      grupoExibicao: props.updateRevisionItem.grupoExibicao,
      carro: props.updateRevisionItem.carro,
      revisao: props.updateRevisionItem.revisao,
      codigoFabrica: props.updateRevisionItem.codigoFabrica,
      currentPeca: props.updateRevisionItem.peca,
      codCardapio: props.updateRevisionItem.codCardapio.toString(),
    };

    loading.submit = true;
    await updateRevisionItem(payload)
      .then((r) => {
        showTimeAlert(r.message);
        emitter.emit("update-family", {});
      })
      .catch(() => {
        showTimeAlert("Não foi possível completar a solicitação", "error");
      })
      .finally(() => (loading.submit = false));
  }
};

const getItemDescription = async () => {
  loading.optionDescription = true;
  optionItemDescription.value = await itemDescription();
  loading.optionDescription = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_money = _resolveDirective("money")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: form,
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        "label-width": "auto",
        rules: rules
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_el_form_item, { prop: "peca" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.peca,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.peca) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_el_form_item, { prop: "codigoPeca" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.codigoPeca,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.codigoPeca) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_el_form_item, { prop: "qtdPeca" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: form.qtdPeca,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.qtdPeca) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_el_form_item, { prop: "precoPeca" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_input, {
                    modelValue: form.precoPeca,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.precoPeca) = $event))
                  }, null, 8, ["modelValue"]), [
                    [_directive_money, money]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_el_form_item, { prop: "parcelaPadrao" }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_el_select, {
                    class: "w-100",
                    placeholder: "Escolha uma parcela",
                    modelValue: form.dadosExtra,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.dadosExtra) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Sem descrição",
                        value: 0
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionItemDescription.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codPersonalizacao,
                          label: item.nomePersonalizacao,
                          value: item.codPersonalizacao
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])), [
                    [_directive_loading, loading.optionDescription]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm background_btn_1 text-white",
              id: "kt_button_1",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (submitForm(ruleFormRef.value))),
              disabled: loading.submit
            }, [
              (!loading.submit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                    _hoisted_18,
                    _createTextVNode(" Salvar ")
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_19, [
                    _hoisted_20,
                    _createTextVNode(" Aguarde... ")
                  ]))
            ], 8, _hoisted_16)
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}
}

})